export function validateTextResponse(html) {
    return html.indexOf("<!doctype") === -1;
}
